import { useCallback } from 'react'
import OptionSelect, { SelectOption } from './OptionSelect'
import { api } from 'src/api/root'
import { UpdateLayerMetadataPayload } from 'src/types/layer'

interface LayerMetadataSelectProps<T extends string> {
  fileId: string
  value: T
  options: SelectOption<T>[]
  toPayload: (value: T) => UpdateLayerMetadataPayload
  placeholder?: string
  disabled?: boolean
  className?: string
}

const LayerMetadataSelect = <T extends string>({ fileId, toPayload, ...selectProps }: LayerMetadataSelectProps<T>) => {
  const { mutateAsync } = api.layer.updateMetadata.useMutation()

  const onChange = useCallback(
    async (value: T) => {
      await mutateAsync({ fileId, data: toPayload(value) })
    },
    [mutateAsync, fileId, toPayload],
  )

  return <OptionSelect {...selectProps} onChange={onChange} />
}

export default LayerMetadataSelect
